import { FaChartBar, FaBolt, FaBell, FaFileAlt, FaRobot } from 'react-icons/fa';

const services = [
  {
    icon: <FaChartBar size={36} className="text-[var(--color-secondary)]" />,
    title: 'Pano Kurulumu',
    desc: 'Fabrika ve tesisleriniz için özelleştirilebilir, modern dashboard panoları kuruyoruz.'
  },
  {
    icon: <FaBolt size={36} className="text-[var(--color-tertiary)]" />,
    title: 'Enerji İzleme',
    desc: 'Enerji tüketiminizi anlık olarak izleyin, verimliliği artırın.'
  },
  {
    icon: <FaBell size={36} className="text-[var(--color-fourth)]" />,
    title: 'Alarm Yönetimi',
    desc: 'Kritik durumlar için akıllı alarm ve bildirim sistemleri.'
  },
  {
    icon: <FaFileAlt size={36} className="text-[var(--color-highlight)]" />,
    title: 'Raporlama',
    desc: 'Detaylı raporlar ve analizlerle karar süreçlerinizi destekleyin.'
  },
  {
    icon: <FaRobot size={36} className="text-[var(--color-primary)]" />,
    title: 'Yapay Zeka Destekli Analiz',
    desc: 'Verilerinizi yapay zeka ile analiz ederek öngörüler elde edin.'
  },
];

export default function ServicesList() {
  return (
    <section className="py-16 bg-[var(--color-background)]">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-primary)] mb-10 text-center">Hizmet Kartlarımız</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {services.map((s, i) => (
            <div key={i} className="bg-white rounded-xl shadow-lg p-8 flex flex-col items-center text-center border-t-4" style={{ borderColor: 'var(--color-secondary)' }}>
              <div className="mb-4">{s.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-[var(--color-primary)]">{s.title}</h3>
              <p className="text-[var(--color-black)]">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 